import { render, staticRenderFns } from "./JoinJciMembersList.vue?vue&type=template&id=20ef1638"
import script from "./JoinJciMembersList.vue?vue&type=script&lang=js"
export * from "./JoinJciMembersList.vue?vue&type=script&lang=js"
import style0 from "./JoinJciMembersList.vue?vue&type=style&index=0&id=20ef1638&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports